import _ from 'lodash'
import { OR_SYNTAX, GROUP_SYNTAX } from '@/components/common/pattern/patter-types'

/**
 *
 * @param patternArray{Array} - Pattern that was slitted into array
 * Array<string | { strong: string } | { path: { entity: string; order: number}}>
 * @param orIndex{Number} - index of the OR symbol(|)
 * @param order{Number} - if <0 - left neighbour; +1 right neighbour
 * @returns {String}
 */
const findOrNeighbour = (patternArray, orIndex, order = -1) => {
  order = order < 0 ? -1 : 1
  if (!patternArray[orIndex].strong || patternArray[orIndex].strong !== OR_SYNTAX) {
    throw new Error(`Incorrect or index "${orIndex}". Element: ${JSON.stringify(patternArray[orIndex])}`)
  }
  let j = orIndex + order
  while (j > -1 && j < patternArray.length) {
    if (!_.isString(patternArray[j]) || patternArray[j].trim()) {
      return patternArray[j]
    }
    j += order
  }
  return ''
}
// https://docs.microsoft.com/en-us/azure/cognitive-services/luis/reference-pattern-syntax
export const isValidPatternText = (arr) => {
  // OR("|") should be
  // (a) in the group (checked below)
  // (b) have left & right neighbour
  let numberOfOpenGroups = 0
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].strong) {
      if ([GROUP_SYNTAX.OPEN].includes(arr[i].strong)) {
        numberOfOpenGroups += 1
      } else if ([GROUP_SYNTAX.CLOSE].includes(arr[i].strong)) {
        numberOfOpenGroups -= 1
      } else if (arr[i].strong === OR_SYNTAX) {
        if (numberOfOpenGroups < 1) {
          return false
        }
        const leftNeighbour = findOrNeighbour(arr, i, -1)
        if (leftNeighbour.strong && [OR_SYNTAX, GROUP_SYNTAX.OPEN].includes(leftNeighbour.strong)) {
          return false
        }
        const rightNeighbour = findOrNeighbour(arr, i, 1)
        if (rightNeighbour.strong && [OR_SYNTAX, GROUP_SYNTAX.CLOSE].includes(rightNeighbour.strong)) {
          return false
        }
      }
    }
  }

  // Validating grouping
  const chars = [...Object.values(GROUP_SYNTAX), OR_SYNTAX]
  const s = _
    .chain(arr)
    .filter(el => chars.includes(el.strong))
    .map('strong')
    .join('')
    .value()

  numberOfOpenGroups = 0
  let numberOfOptionals = 0
  const groupOrs = []
  let currentGroupOrs = 0
  const stack = []
  for (const ch of s) {
    currentGroupOrs = groupOrs[groupOrs.length - 1] || 0
    if (currentGroupOrs > 2 || numberOfOptionals > 2 || numberOfOpenGroups > 2 || numberOfOptionals + numberOfOpenGroups > 3) {
      return false
    }
    switch (ch) {
      case GROUP_SYNTAX.OPEN: {
        currentGroupOrs = 0
        groupOrs.push(currentGroupOrs)
        stack.push(ch)
        numberOfOpenGroups++
        break
      }
      case GROUP_SYNTAX.OPTIONAL_OPEN: {
        stack.push(ch)
        numberOfOptionals++
        break
      }
      case OR_SYNTAX: {
        groupOrs[groupOrs.length - 1]++
        break
      }
      case GROUP_SYNTAX.CLOSE: {
        const lastGroup = stack.pop()
        numberOfOpenGroups--
        if (lastGroup !== GROUP_SYNTAX.OPEN || currentGroupOrs < 1) { return false }
        groupOrs.pop()
        break
      }
      case GROUP_SYNTAX.OPTIONAL_CLOSE: {
        const lastGroup = stack.pop()
        numberOfOptionals--
        if (lastGroup !== GROUP_SYNTAX.OPTIONAL_OPEN) { return false }
        break
      }
    }
  }
  return stack.length === 0
}

export const hasAnyEntity = (value) => {
  return !_
    .chain(value)
    .filter(el => _.isObject(el))
    .isEmpty()
    .value()
}

export const splittedPatternsAny = (value, patternAnyEntities) => {
  let prev = null
  for (const item of value) {
    if (_.get(item, 'path.entity') === _.get(prev, 'path.entity') && _.find(patternAnyEntities.value, ['name', _.get(prev, 'path.entity')])) {
      return false
    }
    prev = item
  }
  return true
}
